'use strict';

import Alpine from 'alpinejs';

Alpine.start();
